import {
  parse as fnsParse,
  format,
  isValid,
  isBefore,
  addMonths,
  parseISO,
} from 'date-fns'
import { datetime } from '~/shared/config'

export { addMonths, format }

export const fromString = (input: string) =>
  fnsParse(input, datetime.apiDateFormat, new Date())

export const fromDatetimeString = (input: string) => parseISO(input)

export const isValidDateString = (input: string) => isValid(fromString(input))

export const formatDateForApi = (date: Date) =>
  format(date, datetime.apiDateFormat)

export const formatDateTimeForApi = (date: Date) =>
  format(date, datetime.apiDateTimeFormat)

export const formatDateTimeForUI = (input: string) =>
  format(fromDatetimeString(input), datetime.uiDateTimeFormat)

export const formatDateForUI = (input: string) =>
  format(fromDatetimeString(input), datetime.uiDateFormat)

export const formatTimeForUI = (input: string) =>
  format(fromDatetimeString(input), datetime.uiTimeFormat)

export const isBeforeNow = (date: Date | number) => isBefore(date, new Date())
